import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Booking } from '../../hooks/api/booking';
import { Lesson } from '../../hooks/api/lesson';
import LessonCard from './LessonCard';

interface HomeLessonsListProps {
  bookingsByLessonId: Map<number, Booking[]>;
  currentUserId: string;
  lessons: Lesson[];
  variant: 'default' | 'instructor-desktop';
}

export default function HomeLessonsList({
  bookingsByLessonId,
  currentUserId,
  lessons,
  variant,
}: HomeLessonsListProps) {
  const isInstructorDesktop = variant === 'instructor-desktop';

  return (
    <Box
      className="lesson-times-list"
      sx={{
        display: isInstructorDesktop ? 'grid' : undefined,
        gridTemplateColumns: isInstructorDesktop
          ? {
              xs: '1fr',
              lg: 'repeat(2, minmax(0, 1fr))',
              xl: 'repeat(3, minmax(0, 1fr))',
            }
          : undefined,
        justifyContent: isInstructorDesktop ? 'stretch' : 'center',
        gap: isInstructorDesktop ? 2 : undefined,
      }}
    >
      {isInstructorDesktop && lessons.length === 0 && (
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 4,
            border: '1px dashed rgba(17,17,17,0.14)',
            backgroundColor: '#fafafa',
            textAlign: 'left',
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
            Día sin clases
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Usa el horario semanal para moverte por la agenda o añade una nueva clase para este
            día.
          </Typography>
        </Paper>
      )}

      {lessons.map((lesson) => {
        const lessonBookings = bookingsByLessonId.get(lesson.id) ?? [];
        const userBooking = lessonBookings.find((booking) => booking.userId.toString() === currentUserId);

        return (
          <LessonCard
            key={lesson.id}
            lesson={lesson}
            userBooking={userBooking}
            bookings={lessonBookings}
          />
        );
      })}
    </Box>
  );
}
